import { RegionBadge, RegionFlag } from "./AdminTenants.styles";

interface ITenantRegionBadgeProps {
  /** `EU` or `US` — the only two the API accepts. */
  region: string;
}

const REGION_FLAGS: Record<string, string> = {
  EU: "🇪🇺",
  US: "🇺🇸",
};

/**
 * A tenant's data-residency region, as a coloured pill with its flag.
 *
 * An unrecognised value still renders (in the neutral variant, without a
 * flag) rather than disappearing — if the API ever grows a third region, the
 * column shows it instead of a blank cell.
 */
export function TenantRegionBadge({ region }: ITenantRegionBadgeProps) {
  const normalised = region?.toUpperCase() ?? "";
  const flag = REGION_FLAGS[normalised];
  const variant =
    normalised === "EU" || normalised === "US" ? normalised : "unknown";

  return (
    <RegionBadge region={variant}>
      {flag && <RegionFlag aria-hidden="true">{flag}</RegionFlag>}
      {region || "-"}
    </RegionBadge>
  );
}
